import React from "react";
import styles from "../management.module.scss";
import { useTranslation } from "react-i18next";
import NewsTOPSliderSettingsItem from "./NewsTOPSliderSettingsItem";
import ListWrapper from "../../../common/management/ListWrapper";
import LoadingSpinner from "../../../common/LoadingSpinner";
import NotificationModal from "../../../common/settings-modal/NotificationModal";
import SelenaA from "../../../assets/img/selena-a.webp";
import ActionBtn from "../../../common/management/ActionBtn";

import {
  genNotificationColor,
  genNotificationIcon,
  genNotificationMessage,
  RequestState,
} from "../../../utils/RequestState";

type Props = {
  isLoading: boolean;
  addItem: () => void;
  removeItem: (index: number) => void;
  newsList: Array<{ img: string | File; url: string; isExternal: boolean }>;
  handleInputChange: (index: number, value?: string | File | boolean) => void;
  handleSubmit: () => void;
  requestState: RequestState;
};

const NewsTOPSliderSettings: React.FC<Props> = ({
  isLoading,
  addItem,
  removeItem,
  newsList,
  handleInputChange,
  handleSubmit,
  requestState,
}) => {
  const { t } = useTranslation();
  return (
    <ListWrapper pageTitle={"TOPスライダー設定"}>
      <div className={styles["c-management__box"]}>
        {isLoading ? (
          <LoadingSpinner space={5} />
        ) : (
          <form>
            {newsList.length > 0 ? (
              <NewsTOPSliderSettingsItem
                newsList={newsList}
                handleInputChange={handleInputChange}
                removeItem={removeItem}
              />
            ) : null}

            <div className={styles["c-management__flex-wrapper"]}>
              <ActionBtn
                label={t("スライダーを追加")}
                icon={["fal", "plus-circle"]}
                onClick={() => addItem()}
              />
              <ActionBtn
                label={t("保存して公開")}
                onClick={() => handleSubmit()}
                colorReversal={true}
              />
            </div>
          </form>
        )}
      </div>
      {requestState !== RequestState.Waiting ? (
        <NotificationModal
          color={genNotificationColor(requestState)}
          icon_class={genNotificationIcon(requestState)}
          message={genNotificationMessage(requestState)}
          img_src={requestState === RequestState.Success ? SelenaA : undefined}
        />
      ) : null}
    </ListWrapper>
  );
};

export default NewsTOPSliderSettings;
